export const REQ_ID_HISTORY_DATA = "REQ_ID_HISTORY_DATA";
export const REQ_ID_HISTORY_START_LOADER = "REQ_ID_HISTORY_START_LOADER";
export const REQ_ID_HISTORY_STOP_LOADER = "REQ_ID_HISTORY_STOP_LOADER";
export const REQ_ID_HISTORY_HIDE_ERROR = "REQ_ID_HISTORY_HIDE_ERROR";
export const REQ_ID_HISTORY_ERROR = "REQ_ID_HISTORY_ERROR";
